const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const emailPatternFlexible = /[^@\s]+@[^@\s]+\.[^@\s]+/;
const namePattern = /^[\w'\-,.][^0-9_!¡÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]+$/;
const phoneNumberPattern = /^(\+?\d{1,19})$/;
const codePattern =
    /if\s*\([^)]+\)\s*{[^}]+}|for\s*\([^)]+\)\s*{[^}]+}|while\s*\([^)]+\)\s*{[^}]+}|try\s*{[^}]+}\s*catch\s*\([^)]+\)\s*{[^}]+}\s*finally\s*{[^}]+}|switch\s*\([^)]+\)\s*{[^}]+}|throw\s+new\s+\w+\([^)]*\);?|(const|let|var|int|bool|double|float|long|char|byte|short|void|string|uint|ulong|dynamic)\s+\w+\s*=\s*[^;]+;?|function\s+\w+\s*\([^)]*\)\s*{[^}]+|class\s+\w+\s*{[^}]+|\/\*[\s\S]*?\*\/|(\w+\.)?(\w+)\s*\([^)]*\);?/g;
const linkPattern = /https?:\/\/\S+/i;

export { emailPattern, emailPatternFlexible, namePattern, phoneNumberPattern, codePattern, linkPattern };
